export default class TexsOutGridController {
	/* @ngInject */
	constructor($state) {
		this.$state = $state;
	}
	async $onInit() {
		console.log('TEXS IN GRID INITIALIZED');
	}

	redirectToDAP(id) {
		let url = this.$state.href('daps.edit', { id: id });
		window.open('gestion.html' + url);
	}

	redirectToTicket(id) {
		let url = this.$state.href('tickets.detail', { id: id });
		window.open('gestion.html' + url);
	}

	formatDate(dateString) {
		const date = new Date(dateString);

		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');

		return `${year}/${month}/${day} ${hours}:${minutes}`;
	}
}
